import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1, e as esm} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {B as ButtonBase} from "../../common/index-ef2a811c.js";
import {i as isMuiElement} from "../../common/isMuiElement-5f955b12.js";
import {u as useEnhancedEffect} from "../../common/useEnhancedEffect-d69b40f2.js";
import {u as useForkRef} from "../../common/useForkRef-b591be37.js";
import {L as ListContext_1} from "../../common/ListContext-0f0f18c4.js";
import {L as ListItemButton} from "../../common/index-4dce02d6.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/useEventCallback-f6be53c8.js";
import "../../common/useIsFocusVisible-28d126d4.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
var listItemClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getListItemUtilityClass = getListItemUtilityClass;
  function getListItemUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiListItem", slot);
  }
  const listItemClasses = (0, core.generateUtilityClasses)("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]);
  var _default = listItemClasses;
  exports.default = _default;
});
var listItemSecondaryActionClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getListItemSecondaryActionClassesUtilityClass = getListItemSecondaryActionClassesUtilityClass;
  function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiListItemSecondaryAction", slot);
  }
  const listItemSecondaryActionClasses = (0, core.generateUtilityClasses)("MuiListItemSecondaryAction", ["root", "disableGutters"]);
  var _default = listItemSecondaryActionClasses;
  exports.default = _default;
});
var ListItemSecondaryAction_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _ListContext = interopRequireDefault(ListContext_1);
  const _excluded = ["className"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      disableGutters,
      classes
    } = ownerState;
    const slots = {
      root: ["root", disableGutters && "disableGutters"]
    };
    return (0, core.unstable_composeClasses)(slots, listItemSecondaryActionClasses_1.getListItemSecondaryActionClassesUtilityClass, classes);
  };
  const ListItemSecondaryActionRoot = (0, _styled.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, ownerState.disableGutters && styles.disableGutters];
    }
  })(({
    ownerState
  }) => (0, _extends2.default)({
    position: "absolute",
    right: 16,
    top: "50%",
    transform: "translateY(-50%)"
  }, ownerState.disableGutters && {
    right: 0
  }));
  const ListItemSecondaryAction2 = /* @__PURE__ */ React$1.forwardRef(function ListItemSecondaryAction3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiListItemSecondaryAction"
    });
    const {
      className
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const context = React$1.useContext(_ListContext.default);
    const ownerState = (0, _extends2.default)({}, props, {
      disableGutters: context.disableGutters
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      ownerState,
      ref
    }, other));
  });
  ListItemSecondaryAction2.muiName = "ListItemSecondaryAction";
  var _default = ListItemSecondaryAction2;
  exports.default = _default;
});
var ListItemSecondaryAction = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    listItemSecondaryActionClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _ListItemSecondaryAction.default;
    }
  });
  Object.defineProperty(exports, "listItemSecondaryActionClasses", {
    enumerable: true,
    get: function() {
      return _listItemSecondaryActionClasses.default;
    }
  });
  var _ListItemSecondaryAction = interopRequireDefault(ListItemSecondaryAction_1);
  var _listItemSecondaryActionClasses = _interopRequireWildcard(listItemSecondaryActionClasses_1);
  Object.keys(_listItemSecondaryActionClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _listItemSecondaryActionClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _listItemSecondaryActionClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var ListItem_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.overridesResolver = exports.default = exports.ListItemRoot = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  var _isMuiElement = interopRequireDefault(isMuiElement);
  var _useEnhancedEffect = interopRequireDefault(useEnhancedEffect);
  var _useForkRef = interopRequireDefault(useForkRef);
  var _ListContext = interopRequireDefault(ListContext_1);
  var _listItemClasses = _interopRequireWildcard(listItemClasses_1);
  var _ListItemSecondaryAction = interopRequireDefault(ListItemSecondaryAction);
  const _excluded = ["className"], _excluded2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const overridesResolver = (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
  };
  exports.overridesResolver = overridesResolver;
  const useUtilityClasses = (ownerState) => {
    const {
      alignItems,
      button,
      classes,
      dense,
      disabled,
      disableGutters,
      disablePadding,
      divider,
      hasSecondaryAction,
      selected
    } = ownerState;
    const slots = {
      root: ["root", dense && "dense", !disableGutters && "gutters", !disablePadding && "padding", divider && "divider", disabled && "disabled", button && "button", alignItems === "flex-start" && "alignItemsFlexStart", hasSecondaryAction && "secondaryAction", selected && "selected"],
      container: ["container"]
    };
    return (0, core.unstable_composeClasses)(slots, _listItemClasses.getListItemUtilityClass, classes);
  };
  const ListItemRoot = (0, _styled.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left"
  }, !ownerState.disablePadding && (0, _extends2.default)({
    paddingTop: 8,
    paddingBottom: 8
  }, ownerState.dense && {
    paddingTop: 4,
    paddingBottom: 4
  }, !ownerState.disableGutters && {
    paddingLeft: 16,
    paddingRight: 16
  }, !!ownerState.secondaryAction && {
    paddingRight: 48
  }), !!ownerState.secondaryAction && {
    [`& > .${ListItemButton.listItemButtonClasses.root}`]: {
      paddingRight: 48
    }
  }, {
    [`&.${_listItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`&.${_listItemClasses.default.selected}`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${_listItemClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    },
    [`&.${_listItemClasses.default.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    }
  }, ownerState.alignItems === "flex-start" && {
    alignItems: "flex-start"
  }, ownerState.divider && {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundClip: "padding-box"
  }, ownerState.button && {
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shortest
    }),
    "&:hover": {
      textDecoration: "none",
      backgroundColor: theme.palette.action.hover,
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${_listItemClasses.default.selected}:hover`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      }
    }
  }, ownerState.hasSecondaryAction && {
    paddingRight: 48
  }));
  exports.ListItemRoot = ListItemRoot;
  const ListItemContainer = (0, _styled.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles) => styles.container
  })({
    position: "relative"
  });
  const ListItem2 = /* @__PURE__ */ React$1.forwardRef(function ListItem3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiListItem"
    });
    const {
      alignItems = "center",
      autoFocus = false,
      button = false,
      children: childrenProp,
      className,
      component: componentProp,
      components = {},
      componentsProps = {},
      ContainerComponent = "li",
      ContainerProps: {
        className: ContainerClassName
      } = {},
      dense = false,
      disabled = false,
      disableGutters = false,
      disablePadding = false,
      divider = false,
      focusVisibleClassName,
      secondaryAction,
      selected = false
    } = props, ContainerProps = (0, _objectWithoutPropertiesLoose2.default)(props.ContainerProps, _excluded), other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded2);
    const context = React$1.useContext(_ListContext.default);
    const childContext = {
      dense: dense || context.dense || false,
      alignItems,
      disableGutters
    };
    const listItemRef = React$1.useRef(null);
    (0, _useEnhancedEffect.default)(() => {
      if (autoFocus) {
        if (listItemRef.current) {
          listItemRef.current.focus();
        }
      }
    }, [autoFocus]);
    const children = React$1.Children.toArray(childrenProp);
    const hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ["ListItemSecondaryAction"]);
    const ownerState = (0, _extends2.default)({}, props, {
      alignItems,
      autoFocus,
      button,
      dense: childContext.dense,
      disabled,
      disableGutters,
      disablePadding,
      divider,
      hasSecondaryAction,
      selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    const Root = components.Root || ListItemRoot;
    const rootProps = componentsProps.root || {};
    const componentProps = (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, rootProps.className, className),
      disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
      componentProps.component = componentProp || "div";
      componentProps.focusVisibleClassName = (0, _clsx.default)(_listItemClasses.default.focusVisible, focusVisibleClassName);
      Component = _ButtonBase.default;
    }
    if (hasSecondaryAction) {
      Component = !componentProps.component && !componentProp ? "div" : Component;
      if (ContainerComponent === "li") {
        if (Component === "li") {
          Component = "div";
        } else if (componentProps.component === "li") {
          componentProps.component = "div";
        }
      }
      return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
        value: childContext,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(ListItemContainer, (0, _extends2.default)({
          as: ContainerComponent,
          className: (0, _clsx.default)(classes.container, ContainerClassName),
          ref: handleRef,
          ownerState
        }, ContainerProps, {
          children: [/* @__PURE__ */ (0, _jsxRuntime.jsx)(Root, (0, _extends2.default)({}, rootProps, !(0, core.isHostComponent)(Root) && {
            as: Component,
            ownerState: (0, _extends2.default)({}, ownerState, rootProps.ownerState)
          }, componentProps, {
            children
          })), children.pop()]
        }))
      });
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
      value: childContext,
      children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(Root, (0, _extends2.default)({}, rootProps, {
        as: Component,
        ref: handleRef,
        ownerState
      }, !(0, core.isHostComponent)(Root) && {
        ownerState: (0, _extends2.default)({}, ownerState, rootProps.ownerState)
      }, componentProps, {
        children: [children, secondaryAction && /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ListItemSecondaryAction.default, {
          children: secondaryAction
        })]
      }))
    });
  });
  var _default = ListItem2;
  exports.default = _default;
});
var ListItem = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    listItemClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _ListItem.default;
    }
  });
  Object.defineProperty(exports, "listItemClasses", {
    enumerable: true,
    get: function() {
      return _listItemClasses.default;
    }
  });
  var _ListItem = interopRequireDefault(ListItem_1);
  var _listItemClasses = _interopRequireWildcard(listItemClasses_1);
  Object.keys(_listItemClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _listItemClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _listItemClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(ListItem);
export default __pika_web_default_export_for_treeshaking__;
